import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { QuickQuoteForm } from '../components/QuickQuoteForm';

export const UltrassomPage = () => {
  const equipment = {
    name: "Ultrassom",
    subtitle: "Série Aplio A - Canon Medical",
    description: "A Série A é focada em departamentos de imagem de rotina que exigem alta produtividade e uma ampla gama de aplicações avançadas. Integra tecnologias de imagem avançadas para aumentar a confiança clínica, sendo ideal para departamentos que realizam muitos exames diariamente e precisam de robustez.",
    image: "https://static.prod-images.emergentagent.com/jobs/7899ab28-0d6a-4e3b-b0e7-b178b443ae26/images/70017e5f86d73364cd042f82e87e693bcf5e0f63c4438b9a227fd44c572a77ac.png",
    features: [
      "Alta produtividade para rotinas intensas",
      "Ampla gama de aplicações avançadas",
      "Tecnologias de imagem para maior confiança clínica",
      "Design robusto para alto volume de exames",
      "Opções especializadas como a550 WHC (Saúde da Mulher)",
      "Integração completa com sistemas hospitalares"
    ],
    technicalFeatures: [
      { name: "iSMI", description: "Visualização microvascular avançada para detecção de fluxo sanguíneo de baixa velocidade" },
      { name: "Precision+", description: "Contornos mais nítidos e menor ruído para diagnósticos mais precisos" },
      { name: "Alta Produtividade", description: "Ideal para departamentos com grande volume de exames diários" },
      { name: "a550 WHC", description: "Versão especializada para Saúde da Mulher (Women's Health Care)" }
    ]
  };

  return (
    <div className="min-h-screen pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-600 via-blue-700 to-cyan-600 py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-6">
            <h1 className="text-4xl sm:text-5xl font-bold text-white">
              {equipment.name}
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              {equipment.subtitle}
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div>
              <div className="rounded-2xl overflow-hidden shadow-xl bg-gray-100 sticky top-32">
                <img 
                  src={equipment.image} 
                  alt={equipment.name}
                  className="w-full h-96 object-cover"
                />
              </div>
            </div>
            <div className="space-y-8">
              <p className="text-lg text-gray-600">
                {equipment.description}
              </p>
              
              <div className="space-y-3">
                <h3 className="font-semibold text-gray-900 text-xl">Diferenciais:</h3>
                <ul className="space-y-2">
                  {equipment.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start space-x-3">
                      <CheckCircle className="text-green-500 flex-shrink-0 mt-0.5" size={20} />
                      <span className="text-gray-600">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <Card className="bg-gray-50">
                <CardContent className="p-6">
                  <h3 className="font-semibold text-gray-900 mb-4 text-xl">Recursos Técnicos de Destaque:</h3>
                  <div className="space-y-4">
                    {equipment.technicalFeatures.map((tech, idx) => (
                      <div key={idx} className="border-l-4 border-blue-600 pl-4">
                        <p className="font-semibold text-gray-900">{tech.name}</p>
                        <p className="text-sm text-gray-600">{tech.description}</p>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>

              <QuickQuoteForm equipmentName={equipment.name} />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-blue-600">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <div className="space-y-6">
            <h2 className="text-3xl sm:text-4xl font-bold text-white">
              Interessado na Série Aplio A?
            </h2>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto">
              Entre em contato para conhecer todas as configurações disponíveis
            </p>
            <Link to="/contact">
              <Button size="lg" className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-6 text-lg">
                Fale Conosco
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
